var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarnBannerBg = function SvgEarnBannerBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1761,
    height: 502,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Earn_Banner_BG_svg__a)",
    filter: "url(#Earn_Banner_BG_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(18 16)",
    fill: "url(#Earn_Banner_BG_svg__c)",
    d: "M0 0h1721v462H0z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#Earn_Banner_BG_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeMiterlimit: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1756.89 1442.35c-178.06 40.26-386.07-27.52-475.61-186.72-37.55-66.74-52.62-143.77-60.49-219.95-19.85-192.533 2.79-389.506-38.59-578.596-15.75-71.99-53.69-153.469-126.54-164.166-65.306-9.591-122.119 43.82-161.042 97.173-54.361 74.53-96.411 157.546-129.782 243.549-37.905 97.675-65.752 201.237-126.267 286.737-60.515 85.503-165.433 150.653-267.382 126.803-99.037-23.16-160.886-117.772-230.884-191.599-21.018-22.169-45.537-43.964-75.752-48.4C18.27 800.39-22.505 835.638-55.99 868.33",
    stroke: "#5C5C5C",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1759.72 1436.26c-176.65 38.83-382.19-28.04-472.66-184.22-37.93-65.47-54.06-141.07-63.07-215.98-11.89-98.942-12.34-199.302-15.92-299.346-3.27-91.43-9.2-182.544-29.24-271.906-15.98-71.243-53.53-151.143-124.8-163.577-50.46-8.787-96.085 18.837-132.928 55.593-10.416 10.366-20.129 21.422-29.024 32.563-22.08 27.667-42.481 57.043-61.103 87.998-20.918 34.775-39.425 71.459-56.039 108.918a1297.845 1297.845 0 0 0-18.35 43.489c-39.41 98.106-68.635 202.271-130.126 288.431-59.754 84.117-162.593 148.487-262.705 126.607-97.272-21.24-158.748-111.747-228.187-182.501-20.86-21.25-45.106-42.154-74.876-46.318-45.594-6.375-85.88 27.796-119.122 59.412",
    stroke: "#606060",
    strokeWidth: 0.73
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1762.53 1430.16c-175.23 37.39-378.31-28.57-469.69-181.72-38.32-64.23-55.49-138.37-65.65-212.02-13.41-97.278-15.52-196.202-20.34-295.026-4.39-90.295-11.06-180.447-31.41-268.89-16.22-70.511-53.37-148.86-123.05-162.974-50-10.122-95.45 14.315-132.995 48.572-10.617 9.648-20.617 20.029-29.856 30.567-22.898 26.174-44.303 54.445-63.829 84.926-21.922 34.243-41.119 71.056-58.335 108.644a1320.703 1320.703 0 0 0-19.038 43.662c-40.903 98.551-71.706 203.161-134 290.111-59.166 82.614-159.766 146.318-258.042 126.408-95.507-19.31-156.596-105.719-225.475-173.401-20.703-20.316-44.676-40.345-74.001-44.25-44.892-5.973-84.69 27.136-117.702 57.661",
    stroke: "#646464",
    strokeWidth: 0.72
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1765.36 1424.07c-173.83 35.94-374.43-29.09-466.74-179.21-38.72-62.96-56.92-135.67-68.23-208.07-14.93-95.609-18.72-193.098-24.76-290.701-5.51-89.175-12.93-178.365-33.57-265.875-16.46-69.764-53.24-146.621-121.32-162.385-49.57-11.472-94.818 9.792-133.067 41.551-10.832 8.93-21.119 18.636-30.688 28.571-23.701 24.681-46.14 51.86-66.555 81.853-22.926 33.698-42.825 70.64-60.63 108.372-6.843 14.487-13.4 29.118-19.713 43.848-42.409 98.982-74.675 204.123-137.859 291.806-58.492 81.164-156.926 144.15-253.365 126.2-93.757-17.37-154.444-99.682-222.764-164.291-20.545-19.397-44.246-38.536-73.126-42.169-44.202-5.556-83.498 26.461-116.28 55.923",
    stroke: "#686868",
    strokeWidth: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1768.17 1417.97c-172.42 34.5-370.55-29.61-463.78-176.71-39.11-61.7-58.36-132.97-70.8-204.11-16.46-93.959-21.91-189.983-29.18-286.38-6.61-88.056-14.81-176.27-35.75-262.861-16.69-69.031-53.14-144.423-119.58-161.782-49.142-12.85-94.134 5.356-133.143 34.53-11.033 8.242-21.606 17.244-31.52 26.576-24.519 23.188-47.962 49.276-69.281 78.781-23.945 33.152-44.533 70.223-62.94 108.099-7.073 14.544-13.859 29.232-20.401 44.02-43.916 99.427-77.645 205.085-141.733 293.486-57.803 79.742-154.099 141.981-248.702 126.001-91.993-15.45-152.307-93.654-220.067-155.191-20.387-18.478-43.815-36.741-72.236-40.086-43.5-5.155-82.308 25.801-114.861 54.186",
    stroke: "#6C6C6C",
    strokeWidth: 0.68
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1771 1411.88c-171.02 33.05-366.67-30.12-460.81-174.21-39.5-60.43-59.8-130.27-73.39-200.15-17.97-92.29-25.09-186.878-33.6-282.055-7.73-86.922-16.67-174.173-37.91-259.845-16.93-68.3-53.03-142.256-117.85-161.194-48.736-14.243-93.484.862-133.224 27.509-11.234 7.538-22.109 15.866-32.353 24.581-25.322 21.694-49.783 46.677-72.021 75.708-24.949 32.606-46.225 69.821-65.235 107.826a1325.032 1325.032 0 0 0-21.075 44.207c-45.423 99.858-80.615 206.061-145.592 295.179-57.101 78.307-151.259 139.814-244.026 125.804-90.242-13.53-150.154-87.627-217.355-146.091-20.215-17.545-43.4-34.932-71.361-38.019-42.811-4.738-81.132 25.14-113.44 52.448",
    stroke: "#707070",
    strokeWidth: 0.67
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1773.82 1405.78c-169.61 31.62-362.79-30.64-457.85-171.72-39.88-59.16-61.23-127.56-75.97-196.18-19.49-90.626-28.27-183.778-38-277.735-8.85-85.801-18.55-172.076-40.09-256.83-17.15-67.553-52.94-140.145-116.09-160.59-48.35-15.65-92.854-3.633-133.298 20.474-11.448 6.834-22.61 14.472-33.184 22.584-26.14 20.216-51.62 44.093-74.747 72.636-25.953 32.06-47.933 69.405-67.545 107.553a1322.024 1322.024 0 0 0-21.75 44.38c-46.914 100.302-83.57 207.023-149.465 296.873-56.398 76.885-148.433 137.645-239.363 125.585-88.477-11.6-148.002-81.593-214.644-136.985-20.056-16.626-42.968-33.123-70.486-35.937-42.122-4.336-79.94 24.48-112.02 50.697",
    stroke: "#747474",
    strokeWidth: 0.65
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1776.63 1399.69c-168.18 30.17-358.9-31.15-454.89-169.22-40.29-57.9-62.65-124.87-78.55-192.22-21.02-88.971-31.48-180.659-42.42-273.41-9.96-84.681-20.42-169.995-42.26-253.815-17.4-66.82-52.85-138.077-114.36-160.002-47.957-17.099-92.217-8.14-133.363 13.454a327.633 327.633 0 0 0-34.017 20.589c-26.986 18.665-53.442 41.507-77.473 69.562-26.958 31.515-49.64 68.989-69.84 107.267a1318.026 1318.026 0 0 0-22.439 44.566c-48.421 100.733-86.526 207.999-153.325 298.553-55.68 75.464-145.592 135.476-234.686 125.386-86.712-9.66-145.864-75.565-211.932-127.884-19.899-15.693-42.538-31.314-69.61-33.87-41.42-3.92-78.75 23.819-110.6 48.96",
    stroke: "#787878",
    strokeWidth: 0.63
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.46 1393.59c-166.78 28.73-355.03-31.67-451.93-166.72-40.67-56.64-64.08-122.17-81.13-188.26-22.54-87.307-34.66-177.559-46.84-269.089-11.08-83.562-22.28-167.899-44.42-250.8-17.63-66.074-52.77-136.053-112.62-159.413-47.589-18.564-91.591-12.649-133.441 6.432a316.234 316.234 0 0 0-34.848 18.593c-27.805 17.158-55.264 38.924-80.199 66.491-27.962 30.969-51.333 68.586-72.151 106.993-7.991 14.76-15.681 29.692-23.112 44.739-49.928 101.178-89.468 208.975-157.199 300.247-54.949 74.057-142.766 133.307-230.009 125.187-84.962-7.74-143.712-69.537-209.234-118.783-19.742-14.775-42.108-29.505-68.736-31.788-40.731-3.504-77.574 23.159-109.18 47.222",
    stroke: "#7C7C7C",
    strokeWidth: 0.62
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1782.27 1387.5c-165.37 27.3-351.14-32.19-448.97-164.21-41.06-55.37-65.52-119.47-83.71-184.29-24.06-85.644-37.85-174.46-51.26-264.77-12.2-82.427-24.16-165.802-46.59-247.785-17.87-65.341-52.67-134.071-110.88-158.81-47.22-20.072-90.978-17.143-133.517-.588-12.094 4.709-24.117 10.265-35.68 16.597-28.608 15.664-57.101 36.325-82.925 63.432-28.981 30.439-53.041 68.17-74.446 106.721-8.221 14.817-16.14 29.806-23.802 44.925-51.419 101.609-92.408 209.966-161.057 301.927-54.231 72.65-139.925 131.141-225.346 124.981-83.198-5.81-141.561-63.501-206.523-109.675-19.584-13.841-41.678-27.696-67.847-29.721-40.027-3.101-76.382 22.499-107.759 45.485",
    stroke: "gray",
    strokeWidth: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1785.1 1381.4c-163.97 25.85-347.27-32.71-446-161.71-41.47-54.11-66.96-116.77-86.28-180.35-25.57-83.974-41.04-171.354-55.68-260.444-13.32-81.307-26.03-163.72-48.76-244.769-18.1-64.595-52.58-132.148-109.13-158.222-46.859-21.593-90.344-21.651-133.586-7.609a292.753 292.753 0 0 0-36.512 14.602c-29.426 14.156-58.923 33.74-85.651 60.359-29.985 29.893-54.733 67.754-76.756 106.448a1356.148 1356.148 0 0 0-24.476 45.097c-52.925 102.055-95.349 210.943-164.931 303.622-53.485 71.243-137.099 128.976-220.669 124.786-81.433-3.88-139.423-57.477-203.811-100.579-19.412-12.922-41.248-25.887-66.972-27.639-39.339-2.684-75.192 21.838-106.339 43.748",
    stroke: "#848484",
    strokeWidth: 0.58
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1787.92 1375.31c-162.55 24.41-343.37-33.22-443.04-159.21-41.85-52.85-68.39-114.07-88.86-176.38-27.09-82.329-44.24-168.246-60.1-256.129-14.42-80.187-27.91-161.624-50.92-241.754-18.34-63.863-52.48-130.253-107.4-157.619-46.485-23.158-89.727-26.159-133.657-14.63-12.525 3.288-25.107 7.48-37.345 12.606-30.229 12.663-60.744 31.156-88.376 57.287-30.99 29.347-56.441 67.352-79.051 106.175-8.695 14.918-17.059 30.036-25.151 45.284-54.432 102.485-98.275 211.934-168.79 305.301-52.754 69.836-134.258 126.789-216.007 124.579-79.682-1.95-137.27-51.441-201.114-91.47-19.253-11.988-40.817-24.078-66.096-25.556-38.636-2.283-74 21.177-104.918 41.996",
    stroke: "#888",
    strokeWidth: 0.57
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1790.74 1369.21c-161.15 22.96-339.51-33.74-440.09-156.71-42.24-51.59-69.83-111.37-91.45-172.42-28.61-80.665-47.42-165.145-64.5-251.794-15.54-79.053-29.77-159.528-53.1-238.739-18.58-63.131-52.38-128.415-105.67-157.03-46.107-24.752-89.104-30.682-133.723-21.665-12.74 2.57-25.595 6.087-38.177 10.61-31.046 11.17-62.581 28.557-91.102 54.214-31.994 28.802-58.148 66.936-81.347 105.903-8.924 14.975-17.518 30.136-25.839 45.456C609.804 689.951 564.54 799.973 493.078 894.03c-51.993 68.443-131.432 124.63-211.329 124.38-77.918-.03-135.119-45.412-198.403-82.369-19.096-11.07-40.4-22.269-65.221-23.489-37.947-1.867-72.825 20.517-103.498 40.259",
    stroke: "#8C8C8C",
    strokeWidth: 0.55
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1793.56 1363.12c-159.73 21.53-335.61-34.27-437.12-154.21-42.64-50.32-71.26-108.67-94.03-168.46-30.12-78.996-50.6-162.04-68.92-247.468-16.66-77.934-31.65-157.432-55.26-235.725-18.81-62.384-52.25-126.62-103.93-156.441-45.725-26.375-88.493-35.205-133.8-28.686-12.956 1.866-26.097 4.695-39.009 8.614-31.85 9.677-64.403 25.973-93.843 51.142-32.998 28.256-59.841 66.519-83.657 105.63-9.153 15.032-17.962 30.251-26.513 45.643-57.43 103.36-104.115 213.929-176.523 308.675-51.247 67.05-128.591 122.456-206.667 124.166-76.167 1.91-132.981-39.384-195.691-73.268-18.938-10.137-39.97-20.474-64.346-21.407-37.258-1.465-71.634 19.856-102.078 38.521",
    stroke: "#909090",
    strokeWidth: 0.53
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1796.38 1357.02c-158.34 20.07-331.73-34.79-434.17-151.72-43.03-49.07-72.7-105.97-96.61-164.49-31.65-77.332-53.79-158.926-73.34-243.148-17.76-76.814-33.52-155.35-57.43-232.709-19.06-61.652-52.11-124.855-102.18-155.838-45.323-28.041-87.89-39.728-133.886-35.708-13.171 1.149-26.585 3.302-39.841 6.619-32.654 8.184-66.225 23.389-96.569 48.069-34.016 27.711-61.548 66.118-85.952 105.357-9.383 15.076-18.421 30.366-27.187 45.815-58.937 103.792-107.028 214.935-180.398 310.37-50.486 65.672-125.764 120.293-201.989 123.963-74.403 3.83-130.829-33.366-192.994-64.163-18.78-9.218-39.54-18.665-63.47-19.34-36.556-1.048-70.444 19.196-100.658 36.784",
    stroke: "#949494",
    strokeWidth: 0.52
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1799.2 1350.92c-156.92 18.64-327.85-35.31-431.21-149.2-43.41-47.82-74.13-103.28-99.19-160.54-33.17-75.677-56.99-155.822-77.76-238.823-18.88-75.694-35.38-153.254-59.6-229.694-19.28-60.905-51.95-123.131-100.44-155.25-44.907-29.734-87.273-44.25-133.958-42.728-13.386.431-27.087 1.91-40.673 4.623-33.457 6.691-68.062 20.79-99.295 44.997-35.021 27.165-63.255 65.701-88.262 105.084-9.612 15.133-18.88 30.481-27.876 46.002C580.493 679.628 531.011 791.344 456.68 887.44c-49.712 64.294-122.924 118.12-197.327 123.76-72.638 5.76-128.62-27.449-190.283-55.058-18.593-8.328-39.11-16.856-62.58-17.258-35.868-.646-69.253 18.536-99.252 35.047",
    stroke: "#989898",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1802.01 1344.83c-155.5 17.2-323.96-35.82-428.24-146.7-43.8-46.55-75.55-100.58-101.77-156.59-34.69-74.013-60.17-152.721-82.18-234.503-20-74.559-37.26-151.157-61.76-226.679-19.53-60.172-51.77-121.451-98.71-154.646-44.462-31.458-86.656-48.773-134.029-49.749-13.616-.273-27.575.517-41.506 2.627-34.275 5.198-69.883 18.206-102.02 41.925-36.025 26.633-64.949 65.284-90.558 104.811-9.842 15.19-19.339 30.596-28.55 46.174-61.95 104.667-112.824 216.959-188.13 313.744-48.952 62.915-120.098 115.956-192.65 123.566-70.888 7.69-126.482-21.44-187.57-45.963C45.9 955.438 25.656 947.8 2.63 947.671c-35.164-.23-68.076 17.875-97.83 33.295",
    stroke: "#9C9C9C",
    strokeWidth: 0.48
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1804.84 1338.73c-154.1 15.75-320.09-36.34-425.28-144.21-44.21-45.28-76.99-97.87-104.35-152.62-36.21-72.348-63.35-149.607-86.58-230.182-21.12-73.44-39.13-149.061-63.93-223.664-19.76-59.441-51.56-119.786-96.97-154.058-44.004-33.209-86.04-53.31-134.102-56.784-13.831-.991-28.077-.876-42.338.632-35.078 3.704-71.705 15.621-104.746 38.851-37.029 26.088-66.656 64.883-92.867 104.539-10.072 15.247-19.799 30.711-29.239 46.346-63.442 105.113-115.708 217.978-191.99 315.424-48.177 61.537-117.257 113.784-187.987 123.356-69.123 9.62-124.344-15.401-184.873-36.851-18.278-6.476-38.25-13.238-60.831-13.109-34.476.187-66.885 17.215-96.41 31.558",
    stroke: "#A0A0A0",
    strokeWidth: 0.47
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1807.67 1332.64c-152.7 14.32-316.21-36.85-422.32-141.71-44.59-44.02-78.42-95.17-106.93-148.66-37.73-70.679-66.54-146.502-91-225.857-22.22-72.32-41-146.98-66.09-220.649-20-58.694-51.32-118.163-95.22-153.454-43.517-34.99-85.425-57.848-134.175-63.806-14.046-1.709-28.565-2.268-43.17-1.364-35.881 2.211-73.542 13.022-107.472 35.794-38.034 25.542-68.349 64.466-95.163 104.265-10.301 15.291-20.243 30.826-29.913 46.533-64.948 105.544-118.591 219.012-195.863 317.118-47.388 60.173-114.431 111.617-183.31 123.16-67.359 11.54-122.192-9.375-182.162-27.753-18.12-5.557-37.833-11.429-59.956-11.027-33.772.589-65.694 16.554-94.99 29.821",
    stroke: "#A4A4A4",
    strokeWidth: 0.45
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1810.48 1326.54c-151.29 12.87-312.33-37.37-419.36-139.21-44.98-42.76-79.86-92.48-109.51-144.7-39.25-69.029-69.74-143.402-95.42-221.536-23.34-71.186-42.87-144.884-68.28-217.634-20.23-57.962-51.06-116.556-93.48-152.866-43-36.799-84.806-62.384-134.246-70.826-14.26-2.427-29.066-3.662-44.001-3.36-36.685.732-75.364 10.438-110.199 32.721-39.052 24.997-70.055 64.05-97.472 103.993-10.531 15.348-20.703 30.94-30.588 46.705-66.454 105.988-121.46 220.046-199.722 318.798-46.599 58.794-111.59 109.448-178.647 122.945-65.609 13.48-120.055-3.346-179.45-18.651-17.963-4.623-37.403-9.62-59.081-8.959-33.084 1.005-64.504 15.894-93.57 28.08",
    stroke: "#A8A8A8",
    strokeWidth: 0.43
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1813.3 1320.45c-149.86 11.43-308.44-37.89-416.4-136.7-45.38-41.49-81.29-89.77-112.09-140.73-40.76-67.366-72.93-140.289-99.84-217.217-24.46-70.066-44.75-142.787-70.44-214.619-20.46-57.215-50.78-114.976-91.75-152.277-42.454-38.636-84.175-66.935-134.317-77.847-14.476-3.145-29.555-5.011-44.834-5.356-37.503-.689-77.186 7.854-112.939 29.649-40.056 24.451-71.763 63.648-99.768 103.72-10.76 15.406-21.161 31.055-31.276 46.892C531.699 662.384 475.33 777.059 396.05 876.457c-45.81 57.445-108.764 107.28-173.97 122.743-63.844 15.41-117.917 2.69-176.739-9.548-17.805-3.704-36.972-7.81-58.191-6.877-32.395 1.407-63.327 15.234-92.15 26.345",
    stroke: "#ACACAC",
    strokeWidth: 0.42
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1816.12 1314.35c-148.47 9.98-304.57-38.41-413.44-134.2-45.76-40.23-82.72-87.08-114.67-136.77-42.28-65.702-76.11-137.189-104.26-212.897-25.57-68.945-46.61-140.705-72.61-211.603-20.7-56.483-50.44-113.397-90-151.674-41.847-40.503-83.554-71.473-134.385-84.868a235.312 235.312 0 0 0-45.666-7.352c-38.306-2.182-79.022 5.255-115.664 26.577-41.061 23.905-73.456 63.231-102.064 103.446-10.989 15.449-21.62 31.171-31.95 47.065-69.453 106.864-127.171 222.142-207.456 322.172-45.006 56.081-105.923 105.112-169.293 122.542-62.078 17.332-115.779 8.712-174.042-.445-17.646-2.771-36.54-6.001-57.315-4.795-31.692 1.823-62.136 14.562-90.73 24.592",
    stroke: "#B0B0B0",
    strokeWidth: 0.4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1818.94 1308.26c-147.05 8.55-300.68-38.92-410.48-131.7-46.15-38.97-84.15-84.38-117.25-132.81-43.8-64.047-79.3-134.084-108.67-208.557-26.68-67.826-48.47-138.609-74.77-208.588-20.93-55.737-50.09-111.847-88.26-151.086-41.236-42.384-82.928-76.024-134.462-91.889a235.59 235.59 0 0 0-46.498-9.347c-39.124-3.676-80.845 2.671-118.391 23.504-42.065 23.359-75.163 62.814-104.373 103.174-11.219 15.506-22.08 31.285-32.639 47.251-70.96 107.295-130.011 223.204-211.329 323.866-44.217 54.731-103.097 102.944-164.631 122.341-60.328 19.271-113.64 14.761-171.33 8.661-17.488-1.86-36.11-4.21-56.44-2.73-31.004 2.22-60.946 13.9-89.31 22.86",
    stroke: "#B4B4B4",
    strokeWidth: 0.38
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1821.77 1302.16c-145.65 7.11-296.81-39.45-407.52-129.2-46.54-37.71-85.6-81.68-119.83-128.86-45.32-62.387-82.49-130.974-113.08-204.241-27.8-66.691-50.36-136.513-76.94-205.573-21.18-55.004-49.71-110.296-86.53-150.483-40.557-44.279-82.292-80.561-134.543-98.924-15.107-5.312-31.047-9.189-47.33-11.343-39.942-5.168-82.667.087-121.117 20.431-43.069 22.815-76.87 62.413-106.669 102.902-11.448 15.564-22.524 31.4-33.313 47.423-72.466 107.74-132.837 224.281-215.188 325.56-43.414 53.382-100.256 100.777-159.953 122.141-58.564 21.187-111.504 20.787-168.62 17.757-17.33-.92-35.68-2.39-55.564-.64-30.301 2.64-59.77 13.23-87.889 21.12",
    stroke: "#B8B8B8",
    strokeWidth: 0.37
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1824.58 1296.07c-144.24 5.66-292.92-39.97-404.55-126.7-46.94-36.44-87.02-78.98-122.41-124.9-46.84-60.719-85.68-127.869-117.5-199.916-28.91-65.572-52.22-134.417-79.11-202.558-21.4-54.272-49.28-108.745-84.79-149.894-39.854-46.189-81.661-85.112-134.615-105.945-15.322-6.031-31.549-10.582-48.162-13.339-40.745-6.661-84.503-2.512-123.842 17.359-44.088 22.283-78.564 61.996-108.979 102.628-11.693 15.622-22.984 31.516-33.988 47.61-73.958 108.171-135.649 225.358-219.062 327.24-42.596 52.033-97.43 98.609-155.29 121.94-56.814 23.115-109.352 26.935-165.922 26.865-17.173.04-35.25-.59-54.69 1.42-29.612 3.04-58.578 12.58-86.468 19.38",
    stroke: "#BCBCBC",
    strokeWidth: 0.35
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1827.41 1289.97c-142.83 4.22-289.05-40.49-401.6-124.21-47.33-35.17-88.45-76.28-124.99-120.93-48.36-59.054-88.86-124.769-121.92-195.596-30.03-64.451-54.1-132.334-81.27-199.542-21.65-53.526-48.84-107.209-83.04-149.306-39.099-48.112-80.992-89.764-134.692-112.966a238.817 238.817 0 0 0-48.995-15.334c-41.563-8.141-86.325-5.097-126.568 14.286-45.092 21.737-80.27 61.58-111.274 102.356-11.922 15.664-23.443 31.63-34.676 47.782-75.465 108.616-138.462 226.449-222.922 328.934-41.778 50.697-94.589 96.426-150.613 121.739-55.049 25.037-107.214 32.967-163.21 35.967-17.015.96-34.834 1.22-53.8 3.5-28.91 3.46-57.388 11.92-85.049 17.63",
    stroke: "silver",
    strokeWidth: 0.33
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1830.22 1283.88c-141.42 2.78-285.16-41-398.63-121.69-47.72-33.91-89.88-73.58-127.57-116.97-49.88-57.405-92.05-121.656-126.34-191.276-31.15-63.317-55.97-130.239-83.45-196.528-21.88-52.793-48.37-105.658-81.31-148.702-38.304-50.051-80.355-94.287-134.758-119.987a241.998 241.998 0 0 0-49.827-17.33c-42.366-9.634-88.147-7.681-129.294 11.228-46.096 21.192-81.963 61.178-113.584 102.083-12.152 15.721-23.902 31.73-35.351 47.969-76.97 109.046-141.244 227.554-226.795 330.614-40.96 49.347-91.762 94.258-145.95 121.523-53.284 26.976-105.062 38.996-160.499 45.066-16.843 1.9-34.403 3.03-52.925 5.59-28.22 3.86-56.197 11.25-83.628 15.89",
    stroke: "#C4C4C4",
    strokeWidth: 0.32
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.05 1277.78c-140.02 1.34-281.29-41.52-395.68-119.2-48.12-32.66-91.31-70.88-130.15-113-51.41-55.741-95.25-118.556-130.74-186.956-32.27-62.197-57.85-128.142-85.63-193.512-22.1-52.047-47.84-104.108-79.56-148.114-37.478-51.989-79.744-98.809-134.836-127.008a245.417 245.417 0 0 0-50.658-19.325c-43.184-11.127-89.984-10.28-132.02 8.155-47.101 20.646-83.671 60.762-115.88 101.81-12.381 15.779-24.346 31.846-36.025 48.141-78.477 109.492-144.014 228.675-230.654 332.309-40.143 48.012-88.922 92.09-141.274 121.322-51.534 28.898-102.91 45.028-157.8 54.168-16.686 2.82-33.974 4.84-52.051 7.66-27.517 4.27-55.02 10.59-82.208 14.15",
    stroke: "#C8C8C8",
    strokeWidth: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1835.87 1271.69c-138.6-.11-277.39-42.03-392.71-116.69-48.51-31.4-92.76-68.19-132.74-109.05-52.93-54.072-98.44-115.451-135.16-182.631-33.37-61.077-59.72-126.046-87.79-190.497-22.35-51.314-47.32-102.542-77.83-147.511-36.602-53.941-79.112-103.346-134.907-134.043a249.599 249.599 0 0 0-51.491-21.321c-43.987-12.62-91.805-12.865-134.76 5.083-48.105 20.1-85.378 60.345-118.189 101.537-12.611 15.837-24.806 31.96-36.714 48.328-79.969 109.922-146.783 229.809-234.528 333.988-39.325 46.691-86.095 89.922-136.611 121.121-49.769 30.826-100.772 51.056-155.09 63.276-16.527 3.75-33.542 6.65-51.175 9.73-26.828 4.7-53.829 9.94-80.787 12.42",
    stroke: "#CCC",
    strokeWidth: 0.28
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.68 1265.59c-137.18-1.55-273.52-42.55-389.74-114.2-48.9-30.14-94.19-65.48-135.32-105.1-54.45-52.402-101.62-112.331-139.58-178.304-34.49-59.958-61.58-123.964-89.96-187.483-22.58-50.582-46.75-100.977-76.08-146.922-35.68-55.88-78.476-107.869-134.974-141.064a255.681 255.681 0 0 0-52.323-23.317c-44.806-14.113-93.628-15.449-137.486 2.01-49.124 19.556-87.071 59.944-120.485 101.265-12.841 15.88-25.265 32.075-37.388 48.5-81.476 110.368-149.365 231.087-238.388 335.682-38.42 45.414-83.269 87.754-131.933 120.921-48.005 32.762-98.62 57.082-152.378 72.372-16.37 4.67-33.113 8.46-50.3 11.81-26.14 5.09-52.639 9.27-79.367 10.68",
    stroke: "#D0D0D0",
    strokeWidth: 0.27
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1841.51 1259.5c-268.53-5.91-529.53-156.9-668.68-386.805-63.94-105.658-102.88-224.913-166.46-330.801-34.724-57.818-77.851-112.391-135.052-148.085-57.201-35.693-130.327-50.28-193.367-26.375-50.128 19.01-88.778 59.527-122.78 100.992C454.284 591.443 378.26 733.569 274.848 854.475 171.436 975.381 29.559 1077.55-129.461 1079.49",
    stroke: "#D4D4D4",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M-130.723 643.094c66.814-88.156 176.008-137.116 279.032-145.658 103.025-8.558 201.014 18.607 291.643 55.435 75.436 30.653 148.046 68.342 229.134 85.428 81.088 17.071 174.472 10.94 250.324-40.044 71.347-47.94 117.07-128.616 142.62-209.004 25.55-80.403 34.12-162.888 51.12-244.44 22.94-110.037 64.4-223.649 145.94-307.57 81.53-83.92 210.88-128.63 301.39-80.374 50.41 26.863 84.05 78.494 138.01 98.838",
    stroke: "#000"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M-130.005 647.387c66.354-88.199 174.802-137.704 277.439-147.152 75.594-6.92 148.634 5.399 218.087 26.792 24.791 7.638 49.109 16.425 72.939 25.887 75.436 29.95 148.103 66.964 229.076 83.346 80.917 16.396 173.784 9.648 249.32-41.307 71.06-47.94 116.874-128.185 142.704-208.229a645.898 645.898 0 0 0 6.22-20.36c21.2-73.554 30.11-148.673 46.06-222.945 2.73-12.678 5.7-25.385 8.94-38.106 21.77-85.14 56.14-170.023 112.97-239.012a419.771 419.771 0 0 1 25.48-28.256c81.78-82.858 210.47-126.246 301.1-78.608 50.37 26.519 84.3 77.273 138.16 97.144",
    stroke: "#020202"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M-129.273 651.694c65.895-88.242 173.597-138.307 275.861-148.645 75.264-7.552 148.117 3.992 217.513 24.724 24.762 7.394 49.08 15.952 72.91 25.198 75.436 29.247 148.16 65.586 229.005 81.264 80.73 15.708 173.081 8.357 248.316-42.57 70.787-47.94 116.658-127.755 142.808-207.44 2.21-6.748 4.3-13.496 6.3-20.273 21.49-73.209 30.82-147.998 47.16-221.912a978.079 978.079 0 0 1 9.14-37.904c22.2-84.724 57.02-169.105 114.08-237.332a423.38 423.38 0 0 1 25.58-27.926c82.02-81.795 210.07-123.878 300.8-76.828 50.33 26.16 84.54 76.067 138.33 95.45",
    stroke: "#050505"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M-128.556 655.987c65.436-88.271 172.392-138.91 274.269-150.138 74.919-8.169 147.615 2.599 216.939 22.657 24.748 7.15 49.051 15.491 72.882 24.508 75.435 28.543 148.203 64.208 228.947 79.183 80.543 15.032 172.392 7.078 247.297-43.849 70.5-47.926 116.452-127.338 142.892-206.664a683.58 683.58 0 0 0 6.37-20.172c21.77-72.866 31.52-147.339 48.25-220.893 2.86-12.549 5.95-25.14 9.33-37.718 22.65-84.294 57.9-168.171 115.22-235.652a421.837 421.837 0 0 1 25.69-27.595c82.27-80.734 209.67-121.495 300.5-75.048 50.3 25.815 84.79 74.847 138.5 93.741",
    stroke: "#070707"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.825 660.295c64.963-88.314 171.187-139.5 272.677-151.632 74.575-8.787 147.112 1.192 216.35 20.604 24.734 6.92 49.024 15.032 72.854 23.819 75.435 27.839 148.26 62.829 228.875 77.115 80.371 14.343 171.703 5.786 246.293-45.112 70.228-47.926 116.236-126.907 142.996-205.874 2.27-6.677 4.4-13.382 6.44-20.087 22.05-72.52 32.22-146.678 49.34-219.859 2.93-12.491 6.08-25.011 9.53-37.531 23.09-83.877 58.79-167.252 116.35-233.972a420.409 420.409 0 0 1 25.81-27.265c82.49-79.671 209.26-119.112 300.19-73.267 50.27 25.456 85.05 73.64 138.66 92.046",
    stroke: "#090909"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M-127.107 664.588c64.503-88.343 169.981-140.103 271.083-153.125 74.245-9.419 146.597-.201 215.777 18.536 24.705 6.676 48.995 14.558 72.825 23.13 75.436 27.136 148.318 61.451 228.818 75.033 80.184 13.669 171.014 4.508 245.288-46.375 69.941-47.926 116.036-126.477 143.086-205.085 2.28-6.648 4.44-13.31 6.52-19.986 22.34-72.176 32.93-146.003 50.43-218.825 2.99-12.434 6.23-24.896 9.73-37.33 23.54-83.461 59.67-166.334 117.49-232.293a412.595 412.595 0 0 1 25.91-26.935c82.73-78.608 208.86-116.727 299.89-71.486 50.23 25.111 85.29 72.42 138.83 90.338",
    stroke: "#0C0C0C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M-126.375 668.895c64.044-88.386 168.79-140.705 269.505-154.618 73.901-10.036 146.094-1.608 215.203 16.468 24.691 6.433 48.966 14.1 72.796 22.441 75.436 26.433 148.375 60.073 228.746 72.952 79.999 12.979 170.312 3.216 244.27-47.639 69.654-47.926 115.825-126.06 143.165-204.31a673.25 673.25 0 0 0 6.6-19.899c22.61-71.832 33.63-145.343 51.52-217.806a1007.79 1007.79 0 0 1 9.93-37.143c23.99-83.045 60.56-165.4 118.62-230.599a414.223 414.223 0 0 1 26.02-26.605c82.99-77.545 208.45-114.344 299.6-69.72 50.2 24.752 85.55 71.214 139 88.644",
    stroke: "#0E0E0E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M-125.658 673.188c63.585-88.429 167.585-141.294 267.913-156.111 73.571-10.654 145.592-3.001 214.629 14.401 24.662 6.202 48.937 13.625 72.767 21.751 75.436 25.729 148.433 58.695 228.689 70.884 79.826 12.305 169.623 1.939 243.265-48.902 69.382-47.911 115.625-125.63 143.265-203.52 2.34-6.59 4.55-13.18 6.67-19.799 22.9-71.487 34.32-144.682 52.61-216.772 3.13-12.305 6.49-24.638 10.12-36.957 24.45-82.614 61.45-164.481 119.74-228.918a412.052 412.052 0 0 1 26.12-26.275c83.23-76.483 208.05-111.961 299.29-67.94 50.16 24.408 85.8 69.993 139.17 86.935",
    stroke: "#101010"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-124.927 677.495c63.126-88.458 166.38-141.897 266.321-157.604 73.226-11.285 145.09-4.393 214.055 12.333 24.648 5.959 48.908 13.166 72.739 21.077 75.435 25.026 148.475 57.316 228.617 68.802 79.639 11.616 168.934.646 242.261-50.166 69.094-47.911 115.424-125.198 143.354-202.744a747.51 747.51 0 0 0 6.76-19.713c23.18-71.142 35.02-144.022 53.7-215.738a978.637 978.637 0 0 1 10.31-36.77c24.89-82.198 62.33-163.563 120.87-227.239a405.139 405.139 0 0 1 26.25-25.944c83.45-75.421 207.64-109.578 298.98-66.161 50.13 24.049 86.04 68.788 139.34 85.242",
    stroke: "#131313"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M-124.209 681.788c62.653-88.501 165.175-142.5 264.728-159.097 72.897-11.903 144.574-5.801 213.482 10.265 24.633 5.729 48.879 12.707 72.709 20.388 75.436 24.322 148.533 55.952 228.56 66.72 79.453 10.941 168.246-.631 241.243-51.429 68.822-47.911 115.207-124.768 143.437-201.955a724.589 724.589 0 0 0 6.83-19.612c23.46-70.798 35.73-143.347 54.79-214.719a996.01 996.01 0 0 1 10.52-36.57c25.33-81.78 63.21-162.628 122-225.558a405.839 405.839 0 0 1 26.36-25.614c83.7-74.358 207.33-107.381 298.69-64.38 50.14 23.604 86.29 67.567 139.51 83.533",
    stroke: "#151515"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M-123.478 686.095c62.194-88.529 163.97-143.088 263.151-160.59 72.552-12.52 144.071-7.193 212.893 8.212 24.604 5.485 48.851 12.233 72.681 19.699 75.436 23.604 148.59 54.574 228.488 64.653 79.281 10.251 167.557-1.924 240.238-52.693 68.535-47.897 115.007-124.352 143.537-201.165a644.76 644.76 0 0 0 6.9-19.527c23.75-70.453 36.43-142.686 55.89-213.685a999.447 999.447 0 0 1 10.7-36.382c25.78-81.365 64.1-161.71 123.14-223.879a408.706 408.706 0 0 1 26.45-25.284c83.95-73.296 206.93-105.026 298.37-62.614 50.12 23.245 86.54 66.361 139.67 81.839",
    stroke: "#171717"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.76 690.388c61.734-88.572 162.722-143.892 261.557-162.083 72.194-13.296 143.569-8.601 212.32 6.145 24.59 5.24 48.822 11.773 72.652 19.009 75.436 22.901 148.648 53.195 228.431 62.571 79.094 9.576 166.854-3.216 239.233-53.956 68.263-47.897 114.787-123.921 143.627-200.39a792.924 792.924 0 0 0 6.99-19.426c24.03-70.108 37.13-142.026 56.97-212.651a974.96 974.96 0 0 1 10.9-36.196c26.23-80.934 64.86-160.906 124.26-222.199 8.48-8.744 17.35-17.043 26.57-24.954 84.19-72.233 206.52-102.657 298.07-60.833 50.09 22.886 86.78 65.14 139.84 80.144",
    stroke: "#191919"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M-122.028 694.696c61.275-88.616 161.517-144.51 259.965-163.577 71.849-13.927 143.067-9.993 211.745 4.077 24.576 5.011 48.794 11.314 72.624 18.321 75.436 22.197 148.691 51.816 228.359 60.488 78.907 8.888 166.165-4.493 238.215-55.219 67.975-47.897 114.59-123.49 143.73-199.6a770.01 770.01 0 0 0 7.06-19.326c24.31-69.764 37.83-141.365 58.06-211.632a954.008 954.008 0 0 1 11.1-35.994c26.67-80.518 65.74-159.988 125.39-220.52a391.637 391.637 0 0 1 26.69-24.638c84.43-71.17 206.13-100.288 297.77-59.053 50.05 22.513 87.04 63.935 139.99 78.436",
    stroke: "#1C1C1C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M-121.311 698.988c60.816-88.644 160.312-145.112 258.373-165.07 71.504-14.558 142.55-11.4 211.171 2.01 24.547 4.767 48.765 10.84 72.581 17.632 75.421 21.493 148.748 50.438 228.301 58.407 78.721 8.212 165.477-5.786 237.211-56.483 67.703-47.883 114.384-123.074 143.814-198.825a691.95 691.95 0 0 0 7.13-19.24c24.59-69.405 38.54-140.69 59.15-210.598 3.53-11.945 7.28-23.891 11.31-35.808 27.11-80.101 66.61-159.083 126.52-218.839a388.907 388.907 0 0 1 26.79-24.308c84.66-70.108 205.73-97.919 297.47-57.273 50.01 22.154 87.28 62.715 140.16 76.742",
    stroke: "#1E1E1E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M-120.58 703.296c60.343-88.688 159.107-145.731 256.795-166.563 71.16-15.177 142.048-12.793 210.597-.058 24.533 4.523 48.737 10.381 72.552 16.942 75.422 20.79 148.82 48.888 228.23 56.34 78.564 7.365 164.788-7.064 236.207-57.747 67.416-47.883 114.172-122.643 143.899-198.035a708 708 0 0 0 7.22-19.139c24.87-69.06 39.24-140.03 60.24-209.579 3.59-11.874 7.42-23.762 11.49-35.621 27.56-79.685 67.49-158.164 127.66-217.16 8.61-8.442 17.59-16.411 26.9-23.977 84.9-69.046 205.33-95.55 297.17-55.493 49.98 21.795 87.53 61.509 140.34 75.034",
    stroke: "#202020"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M-119.862 707.589c59.883-88.716 157.887-146.334 255.202-168.057 70.816-15.808 141.546-14.185 210.009-2.125 24.504 4.293 48.708 9.907 72.523 16.253 75.422 20.087 148.878 47.51 228.173 54.258 78.377 6.676 164.085-8.356 235.188-59.01 67.143-47.883 113.971-122.213 143.997-197.26a719.463 719.463 0 0 0 7.29-19.053c25.16-68.716 39.94-139.37 61.33-208.545a978.931 978.931 0 0 1 11.7-35.435c28-79.254 68.36-157.245 128.79-215.465 8.65-8.342 17.66-16.196 27.01-23.647 85.15-67.969 204.93-93.181 296.87-53.727 49.95 21.436 87.79 60.288 140.5 73.339",
    stroke: "#232323"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M-119.13 711.896c59.424-88.759 156.682-146.951 253.609-169.55 70.486-16.439 141.03-15.592 209.435-4.178 24.491 4.049 48.665 9.448 72.495 15.578 75.422 19.383 148.935 46.117 228.101 52.176 78.19 5.987 163.396-9.634 234.184-60.288 66.856-47.868 113.756-121.781 144.086-196.47 2.55-6.303 5.01-12.62 7.36-18.952 25.44-68.371 40.64-138.71 62.42-207.511 3.73-11.759 7.68-23.518 11.9-35.234 28.45-78.838 69.25-156.34 129.91-213.786 8.69-8.227 17.74-15.98 27.11-23.317 85.39-66.906 204.53-90.812 296.57-51.946 49.92 21.092 88.03 59.082 140.67 71.631",
    stroke: "#252525"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M-118.413 716.189c58.965-88.802 155.477-147.554 252.017-171.043 70.142-17.071 140.527-16.985 208.861-6.246 24.476 3.805 48.636 8.988 72.466 14.889 75.422 18.68 148.978 44.739 228.044 50.109 78.018 5.298 162.707-10.927 233.165-61.552 66.584-47.868 113.555-121.365 144.17-195.68a771.783 771.783 0 0 0 7.45-18.866c25.72-68.027 41.35-138.035 63.51-206.492 3.8-11.687 7.81-23.389 12.08-35.047 28.9-78.422 70.13-155.422 131.05-212.106 8.73-8.127 17.83-15.765 27.23-22.987 85.62-65.844 204.12-88.443 296.26-50.165 49.88 20.732 88.27 57.861 140.84 69.936",
    stroke: "#272727"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M-117.681 720.496C-59.175 631.665 36.576 572.34 132.758 547.96c69.797-17.703 140.025-18.392 208.287-8.313 24.447 3.575 48.607 8.514 72.438 14.2 75.421 17.976 149.035 43.346 227.971 48.026 77.832 4.609 162.019-12.204 232.161-62.815 66.297-47.868 113.34-120.934 144.275-194.905 2.59-6.245 5.1-12.491 7.51-18.765 26.02-67.682 42.04-137.374 64.61-205.458 3.86-11.63 7.95-23.26 12.28-34.86 29.34-78.006 71.02-154.504 132.18-210.427 8.78-8.026 17.92-15.549 27.34-22.656 85.87-64.782 203.73-86.074 295.96-48.386 49.86 20.374 88.54 56.656 141 68.242",
    stroke: "#2A2A2A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M-116.964 724.789c58.033-88.874 153.053-148.76 248.846-174.029 69.454-18.32 139.524-19.785 207.714-10.381 24.433 3.331 48.579 8.055 72.409 13.511 75.421 17.272 149.092 41.967 227.914 45.944 77.645 3.92 161.33-13.496 231.157-64.078 66.024-47.868 113.139-120.504 144.354-194.115a705.077 705.077 0 0 0 7.59-18.68c26.29-67.337 42.74-136.714 65.7-204.424 3.93-11.573 8.07-23.145 12.48-34.66 29.78-77.574 71.89-153.584 133.31-208.746 8.82-7.925 17.99-15.348 27.45-22.326 86.11-63.719 203.32-83.705 295.66-46.605 49.82 20.015 88.77 55.435 141.17 66.533",
    stroke: "#2C2C2C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M-116.247 729.096c57.574-88.902 151.848-149.377 247.254-175.522 69.109-18.952 139.007-21.192 207.126-12.448 24.418 3.101 48.55 7.581 72.38 12.821 75.421 16.569 149.135 40.589 227.842 43.863 77.459 3.23 160.628-14.788 230.138-65.342 65.737-47.854 112.939-120.087 144.457-193.34a721.745 721.745 0 0 0 7.68-18.579c26.57-66.993 43.44-136.053 66.78-203.405 4-11.515 8.21-23.015 12.67-34.473 30.23-77.158 72.77-152.665 134.44-207.066 8.87-7.825 18.08-15.133 27.56-21.996 86.36-62.657 202.93-81.322 295.36-44.839 49.79 19.656 89.03 54.229 141.35 64.84",
    stroke: "#2E2E2E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M-115.515 733.389c57.115-88.945 150.642-149.98 245.661-177.015 68.779-19.57 138.505-22.585 206.552-14.516 24.389 2.857 48.521 7.122 72.351 12.132 75.421 15.866 149.193 39.197 227.785 41.796 77.287 2.541 159.939-16.067 229.134-66.606 65.464-47.854 112.723-119.656 144.542-192.55 2.69-6.145 5.25-12.305 7.75-18.493 26.86-66.648 44.14-135.378 67.87-202.371A982.347 982.347 0 0 1 1099 81.48c30.68-76.742 73.66-151.746 135.57-205.387 8.92-7.724 18.16-14.917 27.67-21.665 86.59-61.595 202.52-78.953 295.05-43.059 49.75 19.297 89.28 53.008 141.5 63.131",
    stroke: "#313131"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M-114.798 737.697c56.656-88.989 149.423-150.583 244.083-178.524 68.435-20.201 138.003-23.977 205.978-16.583 24.375 2.614 48.492 6.662 72.323 11.443 75.421 15.162 149.25 37.819 227.713 39.714 77.1 1.866 159.25-17.359 228.129-67.869 65.178-47.854 112.523-119.226 144.632-191.761 2.7-6.116 5.31-12.247 7.82-18.392 27.13-66.304 44.85-134.718 68.96-201.338 4.14-11.385 8.48-22.77 13.07-34.085 31.14-76.31 74.54-150.827 136.7-203.706 8.97-7.624 18.24-14.703 27.78-21.336 86.82-60.532 202.1-76.584 294.74-41.278 49.71 18.952 89.52 51.802 141.67 61.436",
    stroke: "#333"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M-114.066 741.99c56.197-89.018 148.218-151.187 242.491-180.017 68.09-20.818 137.5-25.384 205.404-18.636 24.361 2.383 48.463 6.188 72.293 10.754 75.422 14.458 149.294 36.44 227.642 37.631 76.914 1.178 158.562-18.636 227.111-69.132 64.905-47.84 112.307-118.795 144.735-190.985a791.66 791.66 0 0 0 7.9-18.292c27.42-65.959 45.55-134.058 70.06-200.318 4.2-11.328 8.6-22.642 13.27-33.899 31.57-75.894 75.42-149.908 137.83-202.026 9.01-7.524 18.32-14.487 27.89-21.006 87.07-59.469 201.7-74.2 294.44-39.498 49.68 18.594 89.77 50.583 141.85 59.728",
    stroke: "#353535"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M-113.349 746.297c55.724-89.061 147.013-151.775 240.898-181.51 67.746-21.45 136.984-26.777 204.831-20.703 24.332 2.139 48.435 5.728 72.265 10.064 75.421 13.755 149.35 35.062 227.584 35.564 76.727.488 157.858-19.928 226.106-70.395 64.619-47.84 112.107-118.379 144.815-190.196a688.622 688.622 0 0 0 7.98-18.206c27.7-65.614 46.25-133.383 71.15-199.284a967.486 967.486 0 0 1 13.45-33.712c32.03-75.478 76.31-148.99 138.97-200.333 9.05-7.423 18.4-14.271 28-20.675 87.32-58.407 201.3-71.831 294.14-37.717 49.66 18.234 90.03 49.376 142.01 58.033",
    stroke: "#383838"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M-112.617 750.59c55.264-89.089 145.807-152.378 239.306-183.003 67.401-22.068 136.482-28.184 204.242-22.771 24.318 1.895 48.406 5.269 72.236 9.39 75.422 13.051 149.408 33.238 227.513 33.482 76.54.23 157.17-21.206 225.102-71.659 64.331-47.84 111.891-117.948 144.908-189.421 2.76-6.016 5.45-12.06 8.04-18.105 27.98-65.27 46.96-132.722 72.24-198.251 4.33-11.199 8.87-22.397 13.66-33.525 32.47-75.062 77.18-148.07 140.08-198.652 9.1-7.323 18.49-14.071 28.11-20.36 87.56-57.344 200.9-69.448 293.83-35.951 49.62 17.889 90.28 48.17 142.18 56.339",
    stroke: "#3A3A3A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M-111.899 754.897c54.805-89.132 144.602-152.981 237.727-184.496 67.072-22.685 135.98-29.577 203.668-24.839 24.289 1.666 48.378 4.796 72.193 8.701 75.422 12.348 149.452 32.291 227.455 31.4 76.354-.875 156.482-22.498 224.084-72.922 64.059-47.826 111.69-117.518 145.004-188.631a762.898 762.898 0 0 0 8.138-18.019c28.26-64.925 47.66-132.062 73.32-197.231 4.41-11.142 9.01-22.269 13.86-33.324 32.91-74.632 78.08-147.152 141.22-196.973 9.14-7.208 18.56-13.855 28.22-20.029 87.79-56.282 200.48-67.065 293.54-34.171 49.58 17.53 90.51 46.949 142.34 54.631",
    stroke: "#3C3C3C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M-111.168 759.19c54.346-89.175 143.382-153.584 236.135-185.989 66.727-23.317 135.463-30.984 203.094-26.906 24.275 1.421 48.349 4.336 72.165 8.011 75.421 11.644 149.508 30.912 227.383 29.333 76.182-1.551 155.793-23.776 223.079-74.186 63.772-47.825 111.49-117.101 145.09-187.856a752.161 752.161 0 0 0 8.202-17.918c28.55-64.581 48.37-131.402 74.42-196.198a964.337 964.337 0 0 1 14.05-33.137C1125.8.129 1171.41-71.89 1234.8-120.95c9.18-7.107 18.65-13.64 28.33-19.699 88.03-55.219 200.08-64.696 293.24-32.391 49.54 17.186 90.77 45.744 142.5 52.937",
    stroke: "#3E3E3E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M-110.451 763.497c53.873-89.204 142.178-154.172 234.543-187.482 66.383-23.934 134.961-32.376 202.52-28.974 24.261 1.178 48.32 3.863 72.136 7.323 75.421 10.94 149.566 29.533 227.326 27.251 75.995-2.24 155.104-25.069 222.075-75.45 63.499-47.825 111.274-116.67 145.19-187.066a776.344 776.344 0 0 0 8.281-17.832c28.82-64.236 49.06-130.727 75.5-195.164 4.54-11.027 9.27-22.025 14.25-32.95 33.8-73.8 79.86-145.315 143.48-193.614 9.24-7.006 18.74-13.424 28.44-19.368 88.28-54.158 199.68-62.313 292.93-30.611 49.51 16.827 91.02 44.523 142.68 51.228",
    stroke: "#414141"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M-109.719 767.79c53.414-89.247 140.972-154.775 232.95-188.975 66.053-24.552 134.459-33.784 201.947-31.027 24.231.947 48.291 3.403 72.107 6.633 75.421 10.237 149.609 28.155 227.254 25.169 75.809-2.915 154.401-26.361 221.056-76.713 63.213-47.811 111.074-116.24 145.277-186.276a799.12 799.12 0 0 0 8.364-17.732c29.114-63.892 49.754-130.066 76.594-194.144 4.61-10.955 9.4-21.896 14.45-32.75 34.25-73.382 80.73-144.395 144.62-191.933 9.28-6.906 18.81-13.209 28.55-19.039 88.52-53.094 199.26-59.929 292.63-28.83 49.47 16.483 91.26 43.317 142.85 49.534",
    stroke: "#434343"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M-109.001 772.098c52.954-89.276 139.767-155.365 231.371-190.469 65.709-25.169 133.957-35.176 201.373-33.094 24.217.703 48.263 2.943 72.078 5.944 75.422 9.533 149.667 26.791 227.197 23.087 75.623-3.604 153.713-27.639 220.052-77.991 62.94-47.811 110.859-115.823 145.363-185.501a734.04 734.04 0 0 0 8.436-17.646c29.401-63.547 50.461-129.405 77.691-193.11 4.66-10.898 9.52-21.766 14.65-32.563 34.69-72.952 81.61-143.462 145.73-190.254 9.33-6.805 18.9-12.994 28.67-18.708 88.75-52.032 198.86-57.545 292.33-27.064 49.44 16.124 91.52 42.097 143.01 47.825",
    stroke: "#454545"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M-108.27 776.391c52.495-89.319 138.562-155.968 229.779-191.962 65.365-25.787 133.44-36.569 200.785-35.162 24.203.474 48.234 2.469 72.049 5.255 75.408 8.83 149.724 25.413 227.126 21.019 75.435-4.278 153.023-28.93 219.047-79.254 62.653-47.811 110.658-115.393 145.463-184.711a761.013 761.013 0 0 0 8.508-17.545c29.673-63.203 51.163-128.746 78.783-192.077a976.542 976.542 0 0 1 14.83-32.377c35.14-72.535 82.51-142.543 146.87-188.573 9.37-6.705 18.98-12.779 28.76-18.378 89-50.97 198.46-55.162 292.03-25.284 49.4 15.779 91.77 40.891 143.19 46.131",
    stroke: "#484848"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M-107.552 780.698c52.036-89.362 137.357-156.556 228.187-193.455 65.034-26.404 132.938-37.976 200.21-37.23 24.174.23 48.191 2.01 72.021 4.566 75.407 8.127 149.767 24.035 227.068 18.938 75.264-4.968 152.335-30.209 218.029-80.518 62.38-47.811 110.457-114.962 145.549-183.936 2.941-5.8 5.81-11.615 8.594-17.459 29.954-62.858 51.864-128.07 79.864-191.057 4.81-10.783 9.8-21.522 15.04-32.176 35.58-72.118 83.4-141.624 148-186.894 9.41-6.604 19.07-12.577 28.88-18.047 89.24-49.907 198.05-52.779 291.72-23.504 49.36 15.42 92 39.671 143.34 44.423",
    stroke: "#4A4A4A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.821 784.991C-55.258 695.6 29.331 627.832 119.773 590.043c64.69-27.036 132.436-39.369 199.637-39.297 24.16 0 48.162 1.536 71.993 3.89 75.407 7.409 149.824 22.657 226.996 16.856 75.077-5.642 151.631-31.5 217.024-81.781 62.094-47.796 110.242-114.531 145.635-183.146a813.149 813.149 0 0 0 8.666-17.359c30.246-62.513 52.566-127.41 80.976-190.023a936.924 936.924 0 0 1 15.23-31.99c36.03-71.701 84.29-140.69 149.14-185.199 9.47-6.489 19.14-12.362 28.99-17.717 89.49-48.845 197.65-50.395 291.42-21.723 49.32 15.075 92.26 38.464 143.51 42.728",
    stroke: "#4C4C4C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M-106.104 789.298C-55 699.864 28.843 631.551 118.913 592.857c64.345-27.639 131.933-40.776 199.062-41.365 24.132-.244 48.134 1.077 71.964 3.202 75.407 6.705 149.882 21.278 226.939 14.788 74.89-6.317 150.943-32.778 216.006-83.044 61.821-47.797 110.041-114.115 145.735-182.371a753.012 753.012 0 0 0 8.738-17.258c30.513-62.169 53.273-126.75 82.063-188.99 4.94-10.654 10.06-21.264 15.42-31.803 36.47-71.27 85.18-139.771 150.27-183.519 9.51-6.389 19.23-12.147 29.1-17.387 89.72-47.783 197.22-47.998 291.11-19.943 49.3 14.731 92.51 37.244 143.68 41.034",
    stroke: "#4F4F4F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M-105.372 793.591c50.645-89.477 133.742-158.336 223.424-197.935 64.016-28.256 131.417-42.168 198.489-43.417 24.117-.488 48.105.617 71.935 2.512 75.407 6.002 149.925 19.914 226.867 12.707 74.704-6.992 150.254-34.071 215.002-84.308 61.533-47.797 109.825-113.684 145.821-181.582a846.071 846.071 0 0 0 8.824-17.171c30.8-61.825 53.97-126.089 83.15-187.971 5.01-10.596 10.2-21.149 15.63-31.615 36.91-70.856 86.06-138.84 151.39-181.84 9.55-6.289 19.31-11.932 29.21-17.057 89.95-46.72 196.82-45.615 290.81-18.177 49.25 14.386 92.76 36.038 143.84 39.326",
    stroke: "#515151"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M-104.654 797.898c50.185-89.505 132.536-158.925 221.831-199.428 63.671-28.873 130.915-43.575 197.9-45.485 24.103-.732 48.077.144 71.907 1.824 75.407 5.298 149.982 18.536 226.809 10.624 74.518-7.667 149.566-35.348 213.998-85.571 61.261-47.783 109.624-113.253 145.922-180.792a804.568 804.568 0 0 0 8.895-17.071c31.092-61.48 54.672-125.414 84.242-186.937 5.07-10.538 10.33-21.02 15.83-31.414 37.36-70.44 86.95-137.906 152.52-180.161 9.6-6.188 19.38-11.715 29.31-16.726 90.2-45.658 196.41-43.231 290.51-16.397 49.22 14.028 93.01 34.818 144.01 37.632",
    stroke: "#535353"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M-103.923 802.191c49.726-89.548 131.331-159.513 220.239-200.921 63.341-29.49 130.413-44.968 197.326-47.552 24.075-.962 48.048-.316 71.878 1.134 75.407 4.594 150.04 17.157 226.738 8.543 74.345-8.342 148.877-36.641 212.979-86.835 60.974-47.783 109.409-112.837 146.008-180.017a771.547 771.547 0 0 0 8.967-16.985c31.378-61.135 55.378-124.754 85.338-185.903a929.965 929.965 0 0 1 16.02-31.228c37.82-70.022 87.85-136.987 153.66-178.48 9.64-6.088 19.47-11.501 29.42-16.396 90.45-44.595 196.01-40.834 290.21-14.617 49.18 13.683 93.26 33.612 144.19 35.923",
    stroke: "#565656"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M-103.206 806.499c49.253-89.578 130.126-160.103 218.661-202.415 62.997-30.108 129.896-46.361 196.753-49.62 24.059-1.206 48.019-.775 71.849.445 75.407 3.891 150.082 15.794 226.68 6.476a426.31 426.31 0 0 0 211.975-88.099c60.702-47.782 109.208-112.406 146.094-179.227a873.027 873.027 0 0 0 9.053-16.884c31.651-60.791 56.081-124.094 86.421-184.884 5.21-10.41 10.59-20.776 16.22-31.041 38.26-69.592 88.73-136.053 154.78-176.801 9.7-5.972 19.56-11.285 29.54-16.066 90.69-43.532 195.6-38.45 289.91-12.836 49.14 13.339 93.51 32.391 144.35 34.229",
    stroke: "#585858"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M-102.474 810.792c48.794-89.621 128.936-160.691 217.068-203.908 62.667-30.725 129.395-47.768 196.179-51.688 24.046-1.45 47.991-1.249 71.806-.244 75.407 3.188 150.14 14.415 226.609 4.394 73.972-9.706 147.486-39.211 210.971-89.362 60.414-47.768 109.007-111.976 146.194-178.452a873.235 873.235 0 0 0 9.125-16.798c31.932-60.446 56.782-123.433 87.512-183.85a914.623 914.623 0 0 1 16.42-30.84c38.7-69.176 89.62-135.12 155.9-175.121 9.75-5.872 19.64-11.084 29.64-15.75 90.92-42.47 195.19-36.052 289.61-11.056 49.11 12.994 93.76 31.185 144.52 32.521",
    stroke: "#5A5A5A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M-101.756 815.099c48.334-89.664 127.73-161.28 215.475-205.401 62.323-31.328 128.892-49.161 195.605-53.755 24.017-1.68 47.962-1.709 71.778-.933 75.407 2.484 150.197 13.051 226.551 2.311 73.786-10.38 146.797-40.503 209.952-90.625 60.142-47.768 108.792-111.545 146.28-177.662a830.413 830.413 0 0 0 9.211-16.698c32.224-60.101 57.474-122.758 88.604-182.816 5.34-10.294 10.86-20.517 16.62-30.654 39.15-68.759 90.52-134.2 157.04-173.44 9.78-5.772 19.71-10.869 29.75-15.42 91.16-41.408 194.77-33.655 289.31-9.29 49.06 12.649 94 29.965 144.68 30.826",
    stroke: "#5D5D5D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M-101.025 819.392C-53.149 729.7 25.5 657.524 112.858 612.498c61.993-31.946 128.39-50.568 195.017-55.823 24.002-1.924 47.933-2.182 71.749-1.608 75.407 1.781 150.254 11.687 226.479.244 73.614-11.041 146.108-41.781 208.948-91.889 59.855-47.768 108.591-111.128 146.381-176.872a825.094 825.094 0 0 0 9.282-16.612c32.496-59.756 58.176-122.097 89.696-181.796 5.41-10.223 10.99-20.388 16.8-30.467 39.6-68.343 91.42-133.268 158.17-171.761 9.83-5.671 19.8-10.653 29.88-15.09 91.4-40.345 194.35-31.257 289-7.509 49.04 12.304 94.26 28.758 144.84 29.132",
    stroke: "#5F5F5F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M-100.307 823.699c47.416-89.735 125.334-162.457 212.305-208.387 61.662-32.563 127.873-51.96 194.443-57.876 23.988-2.168 47.904-2.642 71.72-2.297 75.407 1.077 150.297 10.309 226.422-1.838 73.427-11.716 145.405-43.073 207.943-93.152 59.583-47.754 108.376-110.698 146.467-176.097a822.234 822.234 0 0 0 9.354-16.511c32.783-59.412 58.883-121.437 90.783-180.763 5.47-10.166 11.12-20.273 17.01-30.28 40.04-67.912 92.3-132.335 159.3-170.082 9.87-5.57 19.89-10.438 29.97-14.759 91.65-39.283 193.96-28.859 288.71-5.729 48.99 11.96 94.5 27.538 145.01 27.423",
    stroke: "#616161"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M-99.576 827.992c46.943-89.764 124.13-163.046 210.713-209.88 61.318-33.166 127.371-53.368 193.869-59.943 23.959-2.398 47.875-3.102 71.691-2.987 75.407.373 150.384 9.089 226.35-3.92 73.27-12.261 144.717-44.35 206.925-94.416 59.296-47.753 108.175-110.266 146.553-175.307a891.88 891.88 0 0 0 9.44-16.425c33.07-59.067 59.585-120.762 91.875-179.729a924.83 924.83 0 0 1 17.2-30.08c40.49-67.495 93.2-131.4 160.45-168.386 9.92-5.456 19.95-10.223 30.08-14.429 91.88-38.221 193.54-26.462 288.39-3.949 48.95 11.616 94.74 26.332 145.19 25.729",
    stroke: "#646464"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M-98.858 832.299c46.483-89.807 122.924-163.62 209.119-211.373 60.989-33.784 126.87-54.76 193.296-62.011 23.945-2.642 47.846-3.575 71.662-3.675 75.407-.331 150.441 7.71 226.293-5.988 73.083-12.936 144.028-45.643 205.921-95.693 59.008-47.754 107.974-109.851 146.653-174.532a855.975 855.975 0 0 0 9.512-16.325c33.342-58.723 60.282-120.102 92.972-178.71a960.161 960.161 0 0 1 17.38-29.892c40.94-67.08 94.09-130.468 161.56-166.707 9.98-5.356 20.05-10.007 30.2-14.099 92.13-37.158 193.14-24.064 288.09-2.168 48.92 11.27 95 25.111 145.35 24.02",
    stroke: "#666"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M-98.126 836.592c46.024-89.85 121.819-164.05 207.527-212.866 60.716-34.286 126.367-56.153 192.721-64.079 23.916-2.871 47.818-4.034 71.634-4.364 75.407-1.034 150.484 6.331 226.221-8.069 72.911-13.626 143.34-46.921 204.916-96.958 58.736-47.753 107.76-109.419 146.74-173.742a890.337 890.337 0 0 0 9.584-16.224c33.629-58.378 60.993-119.441 94.053-177.676 5.67-9.979 11.53-19.9 17.59-29.706 41.38-66.663 94.99-129.535 162.7-165.027 10.01-5.255 20.13-9.792 30.3-13.769 92.36-36.095 192.72-21.666 287.78-.402 48.88 10.94 95.25 23.905 145.52 22.326",
    stroke: "#686868"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M-97.41 840.9c45.566-89.879 120.615-164.64 205.95-214.36 60.386-34.904 125.851-57.56 192.133-66.146 23.902-3.116 47.789-4.508 71.605-5.054 75.407-1.737 150.542 4.953 226.15-10.151 72.724-14.3 142.651-48.213 203.897-98.221 58.449-47.739 107.559-108.989 146.826-172.966a892.178 892.178 0 0 0 9.67-16.138c33.916-58.034 61.689-118.781 95.149-176.657 5.74-9.921 11.65-19.77 17.79-29.505 41.82-66.232 95.94-128.458 163.83-163.347a301.852 301.852 0 0 1 30.41-13.439c92.61-35.033 192.31-19.268 287.48 1.378 48.85 10.596 95.5 22.685 145.7 20.618",
    stroke: "#6A6A6A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M-96.678 845.193C-51.57 755.271 22.732 679.95 107.68 629.339c60.042-35.52 125.348-58.952 191.559-68.213 23.888-3.36 47.747-4.968 71.577-5.743 75.407-2.441 150.599 3.575 226.092-12.233 72.538-14.989 141.948-49.505 202.893-99.484 58.177-47.739 107.343-108.558 146.926-172.177a936.702 936.702 0 0 0 9.742-16.038c34.188-57.689 62.392-118.106 96.242-175.623 5.81-9.863 11.78-19.64 17.99-29.318 42.26-65.815 96.82-127.539 164.96-161.667a296.387 296.387 0 0 1 30.53-13.109c92.85-33.97 191.86-16.683 287.18 3.159 48.79 10.352 95.75 21.48 145.85 18.923",
    stroke: "#6D6D6D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M-95.96 849.5c44.633-89.951 118.203-165.846 202.764-217.346 59.697-36.153 124.846-60.36 190.985-70.267 23.859-3.589 47.718-5.427 71.548-6.432 75.407-3.144 150.656 2.197 226.02-14.3 72.366-15.665 141.259-50.783 201.889-100.748 57.89-47.739 107.143-108.142 147.012-171.388a883.058 883.058 0 0 0 9.814-15.951c34.475-57.344 63.098-117.446 97.328-174.59a898.96 898.96 0 0 1 18.18-29.13c42.71-65.4 97.71-126.621 166.09-159.988a295.184 295.184 0 0 1 30.63-12.779c93.08-32.907 191.46-14.3 286.88 4.939 48.75 9.993 96 20.26 146.02 17.23",
    stroke: "#6F6F6F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M-95.228 853.793c44.173-89.994 116.998-166.449 201.171-218.84 59.367-36.77 124.344-61.752 190.412-72.334 23.844-3.833 47.689-5.901 71.519-7.107 75.392-3.848 150.713.819 225.963-16.382 72.179-16.353 140.57-52.075 200.87-102.011 57.617-47.725 106.927-107.711 147.113-170.612a1031.126 1031.126 0 0 0 9.899-15.851c34.763-57 63.801-116.785 98.421-173.57 5.94-9.734 12.05-19.397 18.38-28.93 43.15-64.983 98.59-125.688 167.21-158.308a292.476 292.476 0 0 1 30.74-12.448c93.33-31.846 191.06-11.917 286.58 6.705 48.73 9.648 96.24 19.052 146.18 15.52",
    stroke: "#717171"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M-94.511 858.1c43.715-90.037 115.808-167.037 199.593-220.333 59.023-37.387 123.828-63.159 189.838-74.401 23.83-4.078 47.66-6.36 71.49-7.796 75.393-4.552 150.757-.56 225.892-18.464 71.992-17.028 139.881-53.353 199.866-103.275 57.33-47.725 106.726-107.28 147.198-169.822a826.5 826.5 0 0 0 9.971-15.765c35.035-56.655 64.503-116.125 99.513-172.536 6.01-9.677 12.18-19.268 18.58-28.744 43.6-64.552 99.48-124.768 168.34-156.628a292.331 292.331 0 0 1 30.86-12.118c93.57-30.783 190.66-9.533 286.28 8.486 48.68 9.289 96.5 17.832 146.35 13.826",
    stroke: "#747474"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M-93.794 862.393c43.256-90.066 114.603-167.64 198.001-221.826 58.693-38.019 123.326-64.552 189.264-76.469 23.801-4.307 47.631-6.834 71.462-8.485 75.392-5.255 150.814-1.938 225.833-20.532 71.806-17.717 139.179-54.645 198.862-104.538 57.058-47.725 106.526-106.864 147.285-169.047a875.616 875.616 0 0 0 10.043-15.664c35.322-56.311 65.194-115.45 100.604-171.502a891.992 891.992 0 0 1 18.76-28.558c44.05-64.136 100.37-123.85 169.48-154.948a289.895 289.895 0 0 1 30.96-11.787c93.82-29.721 190.24-7.151 285.98 10.265 48.65 8.945 96.74 16.626 146.52 12.118",
    stroke: "#767676"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M-93.062 866.7c42.797-90.108 113.397-168.243 196.408-223.319 58.349-38.636 122.824-65.945 188.676-78.536 23.787-4.552 47.603-7.294 71.419-9.175 75.392-5.958 150.871-3.316 225.762-22.613 71.634-18.392 138.49-55.923 197.843-105.802 56.77-47.71 106.31-106.433 147.385-168.257a960.295 960.295 0 0 0 10.129-15.578c35.609-55.966 65.9-114.79 101.69-170.483a891.35 891.35 0 0 1 18.97-28.37c44.5-63.72 101.24-122.917 170.61-153.255a286.045 286.045 0 0 1 31.08-11.457c94.04-28.658 189.83-4.767 285.67 12.046 48.62 8.586 96.98 15.406 146.68 10.424",
    stroke: "#787878"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M-92.345 870.993c42.323-90.137 112.193-168.832 194.816-224.812 58.019-39.254 122.307-67.352 188.102-80.604 23.758-4.795 47.574-7.753 71.39-9.864 75.393-6.662 150.929-4.695 225.705-24.695 71.447-19.081 137.801-57.215 196.839-107.065 56.498-47.71 106.109-106.003 147.471-167.468a956.918 956.918 0 0 0 10.2-15.477c35.882-55.622 66.602-114.129 102.782-169.45 6.21-9.49 12.58-18.894 19.17-28.17 44.95-63.302 102.13-121.996 171.73-151.573a284.134 284.134 0 0 1 31.19-11.142c94.29-27.595 189.43-2.383 285.37 13.827 48.58 8.241 97.25 14.2 146.86 8.715",
    stroke: "#7B7B7B"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M-91.613 875.301C-20.381 721.889 129.7 600.093 289.152 566.338c98.908-20.948 198.762-10.079 297.009-37.316 145.19-40.259 267.87-159.312 353.664-290.412 42.381-64.753 77.845-133.526 123.225-196.399 45.39-62.872 103.03-121.078 172.87-149.894 152.79-63.044 305.05 30.87 463.37 11.817",
    stroke: "#7D7D7D"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 478.104 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__e)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 457.084 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__f)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 436.05 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__g)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 415.031 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__h)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 393.997 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__i)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 372.977 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__j)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 351.943 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__k)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 330.923 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__l)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.191 309.889 1044 309.53l860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__m)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 288.87 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__n)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 267.836 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__o)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 246.816 860.809-.359 860.81.359-860.81.345-860.809-.345Z",
    fill: "url(#Earn_Banner_BG_svg__p)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 225.782 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__q)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 204.748 860.809-.344 860.81.344-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__r)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.191 183.729 1044 183.37l860.81.359-860.81.358-860.809-.358Z",
    fill: "url(#Earn_Banner_BG_svg__s)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 162.695 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__t)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 141.675 860.809-.359 860.81.359-860.81.359-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__u)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 120.641 860.809-.359 860.81.359L1044 121l-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__v)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.191 99.621 1044 99.262l860.81.36-860.81.358-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__w)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.191 78.587 1044 78.228l860.81.36-860.81.358-860.809-.359Z",
    fill: "url(#Earn_Banner_BG_svg__x)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 57.568 860.809-.36 860.81.36-860.81.359-860.809-.36Z",
    fill: "url(#Earn_Banner_BG_svg__y)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.191 36.534 860.809-.36 860.81.36-860.81.359-860.809-.36Z",
    fill: "url(#Earn_Banner_BG_svg__z)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M246.275-520.07v734.926l164.774 132.665v179.686l111.747 93.985V828",
    stroke: "url(#Earn_Banner_BG_svg__A)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M262.157-527.722v734.925l164.788 132.665v179.686l111.733 93.986v206.807",
    stroke: "url(#Earn_Banner_BG_svg__B)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M278.039-535.375v734.926l164.788 132.65v179.686l111.733 94v206.808",
    stroke: "url(#Earn_Banner_BG_svg__C)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M293.935-543.028v734.912l164.774 132.665v179.686l111.733 93.999v206.794",
    stroke: "url(#Earn_Banner_BG_svg__D)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M309.817-550.695v734.926l164.774 132.665v179.686l111.733 93.985v206.808",
    stroke: "url(#Earn_Banner_BG_svg__E)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M325.699-558.347v734.925l164.774 132.665v179.686l111.733 93.986v206.807",
    stroke: "url(#Earn_Banner_BG_svg__F)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M341.581-566v734.926l164.774 132.65v179.686l111.747 94V782.07",
    stroke: "url(#Earn_Banner_BG_svg__G)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M357.463-532.977v694.25l164.774 132.651V473.61l111.747 93.999v206.808",
    stroke: "url(#Earn_Banner_BG_svg__H)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M373.345-543.028v696.634l164.774 132.665v179.686l111.748 94V766.75",
    stroke: "url(#Earn_Banner_BG_svg__I)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M389.227-517.643v663.596l164.788 132.665v179.686l111.733 93.986v206.808",
    stroke: "url(#Earn_Banner_BG_svg__J)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1379.29 48.58c-.26-3.59-3.37-6.303-6.96-6.045-3.59.259-6.3 3.374-6.04 6.964.26 3.59 3.37 6.303 6.96 6.044 3.59-.258 6.28-3.374 6.04-6.963Z",
    fill: "url(#Earn_Banner_BG_svg__K)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M943.891 381.218a6.872 6.872 0 0 0-7.332-6.36c-3.773.273-6.613 3.546-6.355 7.336a6.87 6.87 0 0 0 7.331 6.361c3.773-.273 6.614-3.546 6.356-7.337Z",
    fill: "url(#Earn_Banner_BG_svg__L)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1036.54 328.109c-.44-6.245-5.87-10.955-12.11-10.51-6.24.446-10.94 5.873-10.5 12.118.45 6.246 5.87 10.955 12.11 10.51 6.24-.445 10.95-5.872 10.5-12.118Z",
    fill: "url(#Earn_Banner_BG_svg__M)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1713.84 48.58c-.25-3.59-3.37-6.303-6.95-6.045a6.525 6.525 0 0 0-6.04 6.964c.25 3.59 3.37 6.303 6.95 6.044 3.59-.258 6.3-3.374 6.04-6.963Z",
    fill: "url(#Earn_Banner_BG_svg__N)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1662.11 303.041c-.43-5.944-5.58-10.41-11.51-9.979-5.94.431-10.4 5.585-9.97 11.515.43 5.944 5.58 10.409 11.51 9.979 5.92-.431 10.4-5.586 9.97-11.515Z",
    fill: "url(#Earn_Banner_BG_svg__O)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M889.444 178.33c-.444 6.246-5.867 10.955-12.108 10.51-6.241-.445-10.947-5.872-10.502-12.118.445-6.246 5.868-10.955 12.109-10.51 6.24.445 10.946 5.872 10.501 12.118Z",
    fill: "url(#Earn_Banner_BG_svg__P)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M889.444 266.343c-.444-6.246-5.867-10.955-12.108-10.51-6.241.445-10.947 5.872-10.502 12.118.445 6.245 5.868 10.954 12.109 10.509 6.24-.445 10.946-5.872 10.501-12.117Z",
    fill: "url(#Earn_Banner_BG_svg__Q)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2504.94427 629.0033 -202.82897 807.7466 -202.273 -41.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D7AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E304B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 465.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 465.835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 465.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 465.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 331.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 331.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 331.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 331.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 331.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 331.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 331.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6710.89 98.717 197.395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 197.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6710.89 98.717 197.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 197.393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 197.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 197.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 63.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 63.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 63.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 63.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 98.717 63.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.49697 -.46378 .46412 6.5018 1372.54 48.956)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.8404 -.4883 .48866 6.84555 936.801 381.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(11.30533 -.80702 .80761 11.31371 1024.99 328.801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.497 -.46378 .46412 6.5018 1707.08 48.97)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.74715 -.76717 .76774 10.75513 1651.08 303.727)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__P",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(11.30533 .80702 -.80761 11.31371 878.14 177.438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Earn_Banner_BG_svg__Q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(11.30533 -.80701 .80761 11.31371 877.905 267.027)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__A",
    x1: 384.536,
    y1: -520.07,
    x2: 384.536,
    y2: 828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__B",
    x1: 400.417,
    y1: -527.722,
    x2: 400.417,
    y2: 820.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__C",
    x1: 416.3,
    y1: -535.375,
    x2: 416.3,
    y2: 812.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__D",
    x1: 432.181,
    y1: -543.028,
    x2: 432.181,
    y2: 805.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__E",
    x1: 448.078,
    y1: -550.695,
    x2: 448.078,
    y2: 797.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__F",
    x1: 463.96,
    y1: -558.347,
    x2: 463.96,
    y2: 789.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__G",
    x1: 479.842,
    y1: -566,
    x2: 479.842,
    y2: 782.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__H",
    x1: 495.724,
    y1: -532.977,
    x2: 495.724,
    y2: 774.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__I",
    x1: 511.606,
    y1: -543.028,
    x2: 511.606,
    y2: 766.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Earn_Banner_BG_svg__J",
    x1: 527.488,
    y1: -517.643,
    x2: 527.488,
    y2: 759.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Earn_Banner_BG_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(18 16)",
    d: "M0 0h1721v462H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Earn_Banner_BG_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(98 -566)",
    d: "M0 0h1971v1394H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Earn_Banner_BG_svg__b",
    x: 0,
    y: 0,
    width: 1761,
    height: 502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1992_13406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1992_13406",
    result: "shape"
  })))));
};
export default SvgEarnBannerBg;